import { render, staticRenderFns } from "./UpdateRequestHeader.vue?vue&type=template&id=10a57f4b&scoped=true&"
import script from "./UpdateRequestHeader.vue?vue&type=script&lang=js&"
export * from "./UpdateRequestHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a57f4b",
  null
  
)

export default component.exports